// extracted by mini-css-extract-plugin
export default {"productGrid":"O0-z","centerLink":"P0-z","productSection":"Q0-z","item":"R0-z","ctaButton":"S0-z"};